<template>
  <!-- 角色权限管理 -->
  <div class="role-permission">
    <el-container>
      <!-- 角色树列表 -->
      <el-aside width="300px">
        <div class="ch-role-list" v-loading="loadingRole">
          <el-tree
            :data="treeData"
            :props="defaultProps"
            @node-click="expandRole"
            style="height: 90%;padding-top: 10px;padding-left: 5px"
          ></el-tree>
        </div>
      </el-aside>
      <el-container>
        <el-header>
          <div class="ch-role-operation">
            <el-button type="primary" @click="addRole">新增角色</el-button>
          </div>
        </el-header>
        <el-main>
          <div>
            <el-table :data="roleInfo" v-if="roleInfo.length !== 0">
              <el-table-column header-align="center" align="center" prop="roleName" label="角色名稱"></el-table-column>
              <el-table-column header-align="center" align="center" label="角色使用人數"></el-table-column>
              <el-table-column header-align="center" align="center" label="最後修改時間"></el-table-column>
              <el-table-column header-align="center" align="center" label="修改人"></el-table-column>
              <el-table-column label="操作" fixed="right">
                <template slot-scope="{row}">
                  <el-button type="primary" size="mini">編輯</el-button>
                  <el-button type="warning" size="mini">刪除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="ch-permission-tree"></div>
        </el-main>
        <el-footer>
          <!-- <el-button type="primary">儲存</el-button> -->
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data () {
    return {
      loadingRole: false,
      treeData: [],
      defaultProps: {
        children: "childNode",
        label: "roleName"
      },
      roleInfo: [],
      roleDialog: false,
      title: "新增角色"
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  async created () {
    this.loadingRole = true;
    let res = await this.axios.get(
      this.pub.getApi().GetRoleInfoTreeByParentID,
      { params: { parentRoleId: this.userInfo.roleID } }
    );
    this.treeData.push(res.data.result);
    this.loadingRole = false;
  },
  methods: {
    expandRole (data) {
      this.roleInfo = [];
      this.roleInfo.push(data);
    },
    addRole () {
      if (this.roleInfo.length === 0) {
        this.$message({
          message: "请先选择角色",
          type: "error",
          showClose: true,
          duration: 2000
        });
        return;
      }
      let queryData = {
        type: "add",
        parentRoleID: this.roleInfo[0].roleID
      };
      this.$router.push({
        name: this.pub.routeNameLists.AddOrEditRole,
        query: queryData
      });
    },
    onCancel () {
      this.roleDialog = false;
    },
    onSubmit () {
      this.roleDialog = false;
    }
  }
};
</script>
<style scoped lang="less">
.role-permission {
  height: 100%;
  .ch-role-list {
    height: 100%;
  }

  .ch-role-operation {
    text-align: left;
  }
}
</style>
